import { ReactNode } from 'react'
import { DispatchType, snackError } from '../snackbar'

export const makeError = (snack: DispatchType, message: ReactNode) => (error?: Error) => {
  snack(snackError(message))
  console.error(error)
}
